exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ml15[data-v-334f8917] {\n    margin-left: 15px;\n}\n#tableList .el-table .cell[data-v-334f8917], .el-table th>div[data-v-334f8917]{\n    padding-left: 0;\n    padding-right: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-334f8917","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/physical/teacherPhy.vue
// module id = ZpWt
// module chunks = 3